export default __webpack_public_path__ + "static/media/faith_logo_classes.31ac08c7.svg";